
document.addEventListener('DOMContentLoaded', function() {
    const section = document.querySelector('.CollectionProductSlider');
    if (!section) return;
 
    const tabs = section.querySelectorAll('.CollectionProductSlider__Tab');
    const collections = section.querySelectorAll('.CollectionProductSlider__CollectionWrapper');
     
    const typeBtns = section.querySelectorAll('.CollectionProductSlider__TypeBtn');
    let currentType = 'opticals';
    
    // Store selected type for each collection tab
    const collectionTypeMap = new Map();  

    function updateCollectionProductSliderProgressBar(swiper) {
        if(!swiper) return;
        const wrapper = swiper.el.closest('.CollectionProductSlider__CollectionWrapper');
        const progressBar = wrapper.querySelector('.CollectionProductSlider__ProgressBar');
        if(!progressBar) return;
        
        // Get Swiper's progress (0 at start, 1 at end)
        let progress = swiper.progress || 0;
        progress = Math.max(0, Math.min(1, progress));
        
        // Calculate minimum width based on visible slides / total slides
        const totalSlides = swiper.slides ? swiper.slides.length : 0;
        
        // Get current slidesPerView based on window width and breakpoints
        let slidesPerView = swiper.params.slidesPerView || 1;
        
        // Check breakpoints to get the correct slidesPerView for current screen size
        if (swiper.params.breakpoints) {
            const currentWidth = window.innerWidth;
            const breakpoints = Object.keys(swiper.params.breakpoints)
                .map(bp => parseInt(bp))
                .sort((a, b) => b - a); // Sort descending
            
            // Find the matching breakpoint
            for (let bp of breakpoints) {
                if (currentWidth >= bp) {
                    const config = swiper.params.breakpoints[bp];
                    if (config && typeof config.slidesPerView === 'number') {
                        slidesPerView = config.slidesPerView;
                        break;
                    }
                }
            }
        }
        
        // Minimum progress = visible slides / total slides
        const minProgress = totalSlides > 0 ? Math.min(1, slidesPerView / totalSlides) : 0;
        
        // Map progress from [0,1] to [minProgress, 1]
        // When progress = 0, width = minProgress
        // When progress = 1, width = 1 (100%)
        const mappedProgress = minProgress + (progress * (1 - minProgress));
        
        // Set the progress bar width
        progressBar.style.width = (mappedProgress * 100) + '%';
    }

    function ensureBellIconsVisible(parentEl) {
        // Ensure all bell icon SVGs are properly rendered without changing button visibility
        const notifyButtons = parentEl.querySelectorAll('.CollectionSliderCard__IconOnlyBtn--notify');
        notifyButtons.forEach((btn, index) => {
            // Check and fix SVG elements
            const defaultIcon = btn.querySelector('.NotifyIcon--default');
            const hoverIcon = btn.querySelector('.NotifyIcon--hover');

            // If there is no default icon for this button, skip processing
            if (!defaultIcon) {
                return;
            }
            
            // Fix clip-path IDs to be unique (prevent SVG rendering conflicts)
            if (defaultIcon) {
                // Check if SVG has content (paths)
                const hasPaths = defaultIcon.querySelectorAll('path').length > 0;
                if (!hasPaths) {
                    console.warn('Bell icon SVG missing paths for button:', btn);
                }
                
                // Make clip-path IDs unique (prevent SVG rendering conflicts)
                const clipPathElements = defaultIcon.querySelectorAll('clipPath');
                clipPathElements.forEach((clipPath, clipIndex) => {
                    const oldId = clipPath.getAttribute('id');
                    if (oldId) {
                        const newId = oldId + '_' + index + '_' + Date.now();
                        clipPath.setAttribute('id', newId);
                        // Update references to this clip-path
                        const references = defaultIcon.querySelectorAll('[clip-path*="' + oldId + '"]');
                        references.forEach(ref => {
                            const clipPathAttr = ref.getAttribute('clip-path');
                            if (clipPathAttr) {
                                ref.setAttribute('clip-path', clipPathAttr.replace(oldId, newId));
                            }
                        });
                    }
                });
                
                // Ensure base sizing
                defaultIcon.style.width = '18px';
                defaultIcon.style.height = '18px';
            }
            
            if (hoverIcon) {
                // Make clip-path IDs unique for hover icon too
                const clipPathElements = hoverIcon.querySelectorAll('clipPath');
                clipPathElements.forEach((clipPath, clipIndex) => {
                    const oldId = clipPath.getAttribute('id');
                    if (oldId) {
                        const newId = oldId + '_hover_' + index + '_' + Date.now();
                        clipPath.setAttribute('id', newId);
                        // Update references to this clip-path
                        const references = hoverIcon.querySelectorAll('[clip-path*="' + oldId + '"]');
                        references.forEach(ref => {
                            const clipPathAttr = ref.getAttribute('clip-path');
                            if (clipPathAttr) {
                                ref.setAttribute('clip-path', clipPathAttr.replace(oldId, newId));
                            }
                        });
                    }
                });
                
                // Ensure hover icon exists and is properly sized
                hoverIcon.style.width = '18px';
                hoverIcon.style.height = '18px';
            }
        });
    }

    function initCardSwipers(parentEl) {
        // Initialize swipers inside cards
        const cardSwipers = parentEl.querySelectorAll('.CollectionSliderCard__InnerSlider');
        cardSwipers.forEach(cs => {
             // Check if swiper already exists and is properly initialized
             if(cs.swiper) {
                 // If swiper exists, just update it to ensure it's in sync
                 try {
                     cs.swiper.update();
                 } catch(e) {
                     // If update fails, destroy and reinitialize
                     cs.swiper.destroy(true, true);
                     cs.swiper = null;
                 }
             }
             
             // If swiper doesn't exist or was destroyed, initialize it
             if(!cs.swiper) {
                 const paginationEl = cs.querySelector('.CollectionSliderCard__Pagination');
                 
                 // Load first image immediately to prevent white space
                 const firstSlide = cs.querySelector('.swiper-slide:first-child');
                 if(firstSlide) {
                     const firstImg = firstSlide.querySelector('img.Image--lazyLoad');
                     if(firstImg && firstImg.dataset.src) {
                         // Load first image immediately
                         firstImg.src = firstImg.dataset.src;
                         firstImg.classList.remove('Image--lazyLoad');
                         firstImg.classList.add('Image--lazyLoaded');
                     }
                 }
                 
                const swiperInstance = new Swiper(cs, {
                    nested: true,
                    allowTouchMove: true,
                    observer: true,
                    observeParents: true,
                    effect: 'fade',  
                    fadeEffect: { 
                        crossFade: true,
                        duration: 500 // Smooth fade duration
                    },
                    speed: 500, // Smooth transition speed
                    pagination: {
                        el: paginationEl,
                        type: 'bullets',
                        clickable: true
                    },
                    autoplay: {
                        delay: 2000,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: false,
                        stopOnLastSlide: false,
                        waitForTransition: true
                    },
                    // Smooth scrolling optimizations for all devices
                    touchEventsTarget: 'container',
                    touchReleaseOnEdges: true,
                    touchRatio: 1,
                    touchAngle: 45,
                    grabCursor: false,
                    resistance: true,
                    resistanceRatio: 0.85,
                    freeMode: false,
                    freeModeSticky: false,
                    on: {
                        init: function() {
                            // Ensure first slide is visible
                            const firstSlide = this.slides[0];
                            if(firstSlide) {
                                firstSlide.style.opacity = '1';
                            }
                        },
                        slideChange: function() {
                            // Preload next image to prevent white space
                            const nextIndex = (this.activeIndex + 1) % this.slides.length;
                            const nextSlide = this.slides[nextIndex];
                            if(nextSlide) {
                                const nextImg = nextSlide.querySelector('img.Image--lazyLoad');
                                if(nextImg && nextImg.dataset.src && !nextImg.src) {
                                    nextImg.src = nextImg.dataset.src;
                                    nextImg.classList.remove('Image--lazyLoad');
                                    nextImg.classList.add('Image--lazyLoaded');
                                }
                            }
                        }
                    }
                });
                 if(swiperInstance.autoplay) {
                     swiperInstance.autoplay.stop();
                 }
             }
        }); 
    }

    function initSwipers() {
        if (typeof Swiper === 'undefined') {
            console.warn('Swiper not loaded yet, retrying in 100ms');
            setTimeout(initSwipers, 100);
            return;
        }

        const swiperContainers = section.querySelectorAll('.swiper-container');
        swiperContainers.forEach(container => { 
            if(container.classList.contains('CollectionSliderCard__InnerSlider')) return;

            if (container.swiper) return; 

            const wrapper = container.closest('.CollectionProductSlider__CollectionWrapper');
            const nextEl = wrapper.querySelector('.swiper-button-next');
            const prevEl = wrapper.querySelector('.swiper-button-prev');

            const isMobile = window.innerWidth <= 768;
             
            if (!wrapper.dataset.currentIndex) {
                wrapper.dataset.currentIndex = '0';
            }
             
            function handleMobileNavigation(direction) {
                const checkMobile = window.innerWidth <= 768;
                if (!checkMobile) return;
                
                const visibleSlides = Array.from(wrapper.querySelectorAll('.CollectionProductSlider__Slide:not(.hidden-type)'));
                const totalSlides = visibleSlides.length;
                const slidesPerPage = 4;
                const maxIndex = Math.max(0, Math.ceil(totalSlides / slidesPerPage) - 1);
                
                let currentIndex = parseInt(wrapper.dataset.currentIndex || '0', 10);
                
                if (direction === 'next') {
                    currentIndex = Math.min(currentIndex + 1, maxIndex);
                } else if (direction === 'prev') {
                    currentIndex = Math.max(currentIndex - 1, 0);
                } else if (direction === 'init') {
                    currentIndex = 0;
                }
                
                // Store current index
                wrapper.dataset.currentIndex = currentIndex.toString();
                
                // Show/hide slides based on current index
                const wrapperEl = container.querySelector('.swiper-wrapper');
                
                // Calculate which slides to show
                const startIdx = currentIndex * slidesPerPage;
                const endIdx = Math.min(startIdx + slidesPerPage, visibleSlides.length);
                
                // Show/hide visible slides
                visibleSlides.forEach((slide, index) => {
                    if (index >= startIdx && index < endIdx) {
                        // Show this slide
                        slide.style.display = 'block';
                        slide.style.opacity = '1';
                        slide.style.visibility = 'visible';
                        slide.classList.remove('mobile-hidden');
                    } else {
                        // Hide this slide
                        slide.style.display = 'none';
                        slide.style.opacity = '0';
                        slide.style.visibility = 'hidden';
                        slide.classList.add('mobile-hidden');
                    }
                });
                
                // Ensure grid layout is maintained
                if (wrapperEl) {
                    wrapperEl.style.display = 'grid';
                }
                
                // Update progress bar
                const progress = totalSlides > slidesPerPage ? (currentIndex + 1) / (maxIndex + 1) : 1;
                const progressBar = wrapper.querySelector('.CollectionProductSlider__ProgressBar');
                if (progressBar) {
                    progressBar.style.width = (progress * 100) + '%';
                }
                
                // Update arrow states
                if (prevEl) {
                    prevEl.classList.toggle('swiper-button-disabled', currentIndex === 0);
                }
                if (nextEl) {
                    nextEl.classList.toggle('swiper-button-disabled', currentIndex >= maxIndex);
                }
            }
            
            const swiper = new Swiper(container, {
                slidesPerView: isMobile ? 4 : 4,
                spaceBetween: isMobile ? 15 : 24,
                observer: true,
                observeParents: true,
                watchSlidesProgress: false,
                slidesPerGroup: isMobile ? 4 : 1,
                allowTouchMove: !isMobile, 
                navigation: isMobile ? false : {
                    nextEl: nextEl,
                    prevEl: prevEl,
                },
                // Smooth scrolling optimizations for all devices
                touchEventsTarget: 'container',
                touchReleaseOnEdges: true,
                touchRatio: 1,
                touchAngle: 45,
                grabCursor: false,
                resistance: true,
                resistanceRatio: 0.85,
                speed: 800,
                freeMode: false,
                freeModeSticky: false,
                watchOverflow: true,
                watchSlidesVisibility: false,
                preventClicks: true,
                preventClicksPropagation: true,
                // Smooth transition settings
                cssMode: false,
                simulateTouch: true,
                followFinger: true,
                threshold: 5,
                longSwipes: true,
                longSwipesRatio: 0.5,
                longSwipesMs: 300,
                breakpoints: {
                    0: { 
                        slidesPerView: 4,
                        slidesPerGroup: 4,
                        spaceBetween: 15,
                        allowTouchMove: false
                    },
                    769: { 
                        slidesPerView: 1.98,
                        slidesPerGroup: 1,
                        spaceBetween: 22,
                        allowTouchMove: true
                    },
                    1024: { 
                        slidesPerView: 3,
                        slidesPerGroup: 1,
                        spaceBetween: 22,
                        allowTouchMove: true
                    },
                    1200: { 
                        slidesPerView: 3.03,
                        slidesPerGroup: 1,
                        spaceBetween: 24
                    },
                    1440: { 
                        slidesPerView: 3,
                        slidesPerGroup: 1,
                        spaceBetween: 24
                    },
                    1700: { 
                        slidesPerView: 4,
                        slidesPerGroup: 1,
                        spaceBetween: 24
                    },
                    2000: { 
                        slidesPerView: 5.1,
                        slidesPerGroup: 1,
                        spaceBetween: 24
                    }
                },
                on: {
                    init: function(s) {
                        initCardSwipers(s.el);
                        if (isMobile) { 
                            handleMobileNavigation('init');
                        } else {
                            // Small delay to ensure breakpoints are applied
                            setTimeout(function() {
                                updateCollectionProductSliderProgressBar(s);
                            }, 50);
                        }
                    },
                    breakpoint: function(s) {
                        // Update progress bar when breakpoint changes
                        if (!isMobile) updateCollectionProductSliderProgressBar(s);
                    },
                    progress: function(s) {
                        if (!isMobile) updateCollectionProductSliderProgressBar(s);
                    },
                    reachEnd: function(s) {
                        // Ensure progress bar is 100% when reaching the end
                        if (!isMobile) updateCollectionProductSliderProgressBar(s);
                    },
                    setTransition: function(s, duration) {
                        if (!isMobile) {
                            const wrapper = s.el.closest('.CollectionProductSlider__CollectionWrapper');
                            const progressBar = wrapper.querySelector('.CollectionProductSlider__ProgressBar');
                            if (progressBar) progressBar.style.transitionDuration = duration + 'ms';
                        }
                    },
                    transitionStart: function(s) {
                        // Force hardware acceleration during transition
                        s.el.style.willChange = 'transform';
                    },
                    transitionEnd: function(s) {
                        // Remove will-change after transition
                        s.el.style.willChange = 'auto';
                        // Update progress bar after transition completes
                        if (!isMobile) updateCollectionProductSliderProgressBar(s);
                    }
                }
            });
             
            if (nextEl && prevEl) { 
                const newNextHandler = (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (window.innerWidth <= 768) {
                        handleMobileNavigation('next');
                    }
                };
                
                const newPrevHandler = (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (window.innerWidth <= 768) {
                        handleMobileNavigation('prev');
                    }
                };
                
                // Remove old listeners and add new ones
                nextEl.removeEventListener('click', newNextHandler);
                prevEl.removeEventListener('click', newPrevHandler);
                
                nextEl.addEventListener('click', newNextHandler, { passive: false });
                prevEl.addEventListener('click', newPrevHandler, { passive: false });
            }
             
            if (!isMobile) {
                updateCollectionProductSliderProgressBar(swiper);
            } else {
                // Initialize mobile navigation - show first 4 products
                // First, ensure all visible products are shown
                const initialVisibleSlides = Array.from(wrapper.querySelectorAll('.CollectionProductSlider__Slide:not(.hidden-type)'));
                initialVisibleSlides.forEach((slide, index) => {
                    if (index < 4) {
                        slide.style.display = 'block';
                        slide.style.opacity = '1';
                        slide.style.visibility = 'visible';
                        slide.classList.remove('mobile-hidden');
                    } else {
                        slide.style.display = 'none';
                        slide.style.opacity = '0';
                        slide.style.visibility = 'hidden';
                        slide.classList.add('mobile-hidden');
                    }
                });
                
                // Then call navigation handler to set up properly
                setTimeout(() => {
                    handleMobileNavigation('init');
                }, 100);
            }

            bindMouseWheelToSlider(swiper, wrapper);
        });
         
        filterSlides(currentType);
    }

    function bindMouseWheelToSlider(swiper, wrapper) {
        if (!swiper || !wrapper || typeof window.CPBindHorizontalWheelScroll !== 'function') return;

        window.CPBindHorizontalWheelScroll({
            swiper: swiper,
            wheelTarget: wrapper,
            bindKey: 'wheelBound',
            isActive: function() {
                return wrapper.classList.contains('is-visible');
            }
        });
    }

    function filterSlides(type) {
        currentType = type;
        const isMobile = window.innerWidth <= 768;
        collections.forEach(wrapper => {
            const slides = wrapper.querySelectorAll('.CollectionProductSlider__Slide');
            const swiperEl = wrapper.querySelector('.swiper-container');
            
            slides.forEach(slide => {
                const slideType = slide.dataset.productType;
                if (slideType === type) {
                    slide.classList.remove('hidden-type');
                    if (!isMobile) {
                        slide.style.display = '';
                    }
                } else {
                    slide.classList.add('hidden-type');
                    slide.style.display = 'none';
                }
            });
            
            if (swiperEl && swiperEl.swiper) {
                if (isMobile) {
                    // Reset currentIndex when filter changes
                    wrapper.dataset.currentIndex = '0';
                    
                    // Use the navigation handler to show first 4 products
                    const container = swiperEl;
                    const visibleSlides = Array.from(wrapper.querySelectorAll('.CollectionProductSlider__Slide:not(.hidden-type)'));
                    
                    // Show first 4 products
                    visibleSlides.forEach((slide, index) => {
                        if (index < 4) {
                            slide.style.display = 'block';
                            slide.style.opacity = '1';
                            slide.style.visibility = 'visible';
                            slide.classList.remove('mobile-hidden');
                        } else {
                            slide.style.display = 'none';
                            slide.style.opacity = '0';
                            slide.style.visibility = 'hidden';
                            slide.classList.add('mobile-hidden');
                        }
                    });
                    
                    // Update progress bar
                    const totalSlides = visibleSlides.length;
                    const progress = totalSlides > 4 ? (1 / Math.ceil(totalSlides / 4)) : 1;
                    const progressBar = wrapper.querySelector('.CollectionProductSlider__ProgressBar');
                    if (progressBar) {
                        progressBar.style.width = (progress * 100) + '%';
                    }
                } else {
                    swiperEl.swiper.update();
                    swiperEl.swiper.slideTo(0);
                    setTimeout(() => updateCollectionProductSliderProgressBar(swiperEl.swiper), 100);
                }
                
                // Re-initialize card swipers for newly visible slides
                // This ensures all visible product cards have their inner swipers properly initialized
                setTimeout(() => {
                    initCardSwipers(wrapper);
                }, 50);
                
                // Ensure bell icons are visible after filtering (with longer delay to ensure DOM is ready)
                setTimeout(() => {
                    ensureBellIconsVisible(wrapper);
                }, 150);
            }
        });
    }

    // Function to toggle type buttons visibility based on collection
    function updateTypeToggleVisibility(collectionWrapper) {
        const typeToggle = section.querySelector('.CollectionProductSlider__TypeToggle');
        if (!typeToggle || !collectionWrapper) return;
        
        const hasOpticals = collectionWrapper.dataset.hasOpticals === 'true';
        const hasSunglasses = collectionWrapper.dataset.hasSunglasses === 'true';
        
        // Show/hide individual buttons based on availability
        const visibleButtons = [];
        typeBtns.forEach(btn => {
            const btnType = btn.dataset.typeFilter;
            const hasType = (btnType === 'opticals' && hasOpticals) || (btnType === 'sunglasses' && hasSunglasses);
            
            if (hasType) {
                btn.style.display = '';
                visibleButtons.push(btn);
            } else {
                btn.style.display = 'none';
            }
        });
        
        // Get currently active button
        const activeBtn = section.querySelector('.CollectionProductSlider__TypeBtn.is-active');
        
        // If active button is hidden, switch to first available type
        if (activeBtn && activeBtn.style.display === 'none' && visibleButtons.length > 0) {
            typeBtns.forEach(b => b.classList.remove('is-active'));
            const firstVisibleBtn = visibleButtons[0];
            firstVisibleBtn.classList.add('is-active');
            currentType = firstVisibleBtn.dataset.typeFilter;
            filterSlides(currentType);
        } 
        // If only one type is available, ensure it's active
        else if (visibleButtons.length === 1) {
            typeBtns.forEach(b => b.classList.remove('is-active'));
            visibleButtons[0].classList.add('is-active');
            currentType = visibleButtons[0].dataset.typeFilter;
            filterSlides(currentType);
        }
        // If both types available and no active button, set first one as active
        else if (visibleButtons.length > 1 && !activeBtn) {
            visibleButtons[0].classList.add('is-active');
            currentType = visibleButtons[0].dataset.typeFilter;
            filterSlides(currentType);
        }
    }

    // Event Listeners
    tabs.forEach(tab => {
        tab.addEventListener('click', () => {
             tabs.forEach(t => t.classList.remove('is-active'));
             tab.classList.add('is-active');
             
             const collectionHandle = tab.dataset.collectionHandler;
             collections.forEach(c => {
                 c.classList.remove('is-visible');
                 if (c.id === 'collection-' + collectionHandle) {
                     c.classList.add('is-visible');
                     
                     // Update type toggle visibility based on current collection
                     updateTypeToggleVisibility(c);
                     
                     // Get selected type for this collection (if visited before) or use default
                     const hasOpticals = c.dataset.hasOpticals === 'true';
                     const hasSunglasses = c.dataset.hasSunglasses === 'true';
                     let selectedType = null;
                     
                     // Check if this collection was visited before
                     if (collectionTypeMap.has(collectionHandle)) {
                         // Use stored type if available in this collection
                         const storedType = collectionTypeMap.get(collectionHandle);
                         if ((storedType === 'opticals' && hasOpticals) || 
                             (storedType === 'sunglasses' && hasSunglasses)) {
                             selectedType = storedType;
                         }
                     }
                     
                     // If no stored type or stored type not available, use default
                     if (!selectedType) {
                         if (hasOpticals) {
                             selectedType = 'opticals';
                         } else if (hasSunglasses) {
                             selectedType = 'sunglasses';
                         }
                     }
                     
                     if (selectedType) {
                         // Update active state on type buttons
                         typeBtns.forEach(btn => {
                             if (btn.dataset.typeFilter === selectedType && btn.style.display !== 'none') {
                                 typeBtns.forEach(b => b.classList.remove('is-active'));
                                 btn.classList.add('is-active');
                                 currentType = selectedType;
                                 filterSlides(selectedType);
                             }
                         });
                     }
                     
                    // Update Swiper layout when becoming visible
                    const swiperEl = c.querySelector('.swiper-container');
                    if (swiperEl && swiperEl.swiper) {
                        swiperEl.swiper.update();
                        updateCollectionProductSliderProgressBar(swiperEl.swiper);
                         // Initialize card swipers for visible collection
                         setTimeout(() => {
                             initCardSwipers(c);
                             // Ensure bell icons are visible when switching tabs
                             ensureBellIconsVisible(c);
                         }, 50);
                     }
                 }
             });
        });
    });

    typeBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            typeBtns.forEach(b => b.classList.remove('is-active'));
            btn.classList.add('is-active');
            const selectedType = btn.dataset.typeFilter;
            currentType = selectedType;
            filterSlides(selectedType);
            
            // Save selected type for current collection tab
            const activeTab = section.querySelector('.CollectionProductSlider__Tab.is-active');
            if (activeTab) {
                const collectionHandle = activeTab.dataset.collectionHandler;
                collectionTypeMap.set(collectionHandle, selectedType);
            }
        });
    });

    // Handle window resize for mobile/desktop switch
    let resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            collections.forEach(wrapper => {
                const swiperEl = wrapper.querySelector('.swiper-container');
                if (swiperEl && swiperEl.swiper) {
                    swiperEl.swiper.update();
                    updateCollectionProductSliderProgressBar(swiperEl.swiper);
                }
            });
        }, 250);
    });
 
    initSwipers();
    
    // Initialize type toggle visibility for first visible collection
    const firstVisibleCollection = section.querySelector('.CollectionProductSlider__CollectionWrapper.is-visible');
    const firstActiveTab = section.querySelector('.CollectionProductSlider__Tab.is-active');
    if (firstVisibleCollection && firstActiveTab) {
        updateTypeToggleVisibility(firstVisibleCollection);
        // Initialize first collection's type (default: opticals)
        const firstCollectionHandle = firstActiveTab.dataset.collectionHandler;
        const hasOpticals = firstVisibleCollection.dataset.hasOpticals === 'true';
        const defaultType = hasOpticals ? 'opticals' : 'sunglasses';
        collectionTypeMap.set(firstCollectionHandle, defaultType);
        currentType = defaultType;
        // Initialize card swipers for first visible collection
        setTimeout(() => {
            initCardSwipers(firstVisibleCollection);
            // Ensure bell icons are visible on initial load
            ensureBellIconsVisible(firstVisibleCollection);
        }, 100);
    }
  });